module.exports = __webpack_public_path__ + "img/beer_id-95.ec33665d.png";